if (typeof window.cpcAddToCart === 'undefined') {

  window.cpcAddToCart = async function(button) {

    if (
      button.classList.contains('loading') ||
      button.disabled
    ) {
      return;
    }

    var buttonText = button.querySelector('.btn-text');
    var variantId = button.getAttribute('data-variant-id');

    button.classList.add('loading');

    if (buttonText) {
      buttonText.textContent = '';
    }

    try {

      var formData = new FormData();

      formData.append('id', variantId);
      formData.append('quantity', 1);

      var sectionIds = [];

      document
        .querySelectorAll('cart-items-component')
        .forEach(function(el) {

          if (
            el.dataset &&
            el.dataset.sectionId
          ) {
            sectionIds.push(el.dataset.sectionId);
          }

        });

      if (sectionIds.length) {
        formData.append(
          'sections',
          sectionIds.join(',')
        );
      }

      var response = await fetch(
        '/cart/add.js',
        {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          }
        }
      );

      var data = await response.json();

      if (data.status) {
        throw new Error(data.description);
      }

      document.dispatchEvent(
        new CustomEvent(
          'cart:update',
          {
            bubbles: true,
            detail: {
              resource: {},
              sourceId: variantId,
              data: {
                source: 'custom-product-card',
                itemCount: 1,
                variantId: variantId,
                sections: data.sections
              }
            }
          }
        )
      );

      if (
        window.customElements &&
        customElements.whenDefined
      ) {

        customElements
          .whenDefined('cart-drawer-component')
          .then(function() {

            var drawer =
              document.querySelector(
                'cart-drawer-component'
              );

            if (
              drawer &&
              typeof drawer.open === 'function'
            ) {
              drawer.open();
            }

          });

      } else {

        var drawer =
          document.querySelector(
            'cart-drawer-component'
          );

        if (
          drawer &&
          typeof drawer.open === 'function'
        ) {
          drawer.open();
        }

      }

    } catch (error) {

      console.error(
        'Cart error:',
        error
      );

      button.classList.remove('loading');

      if (buttonText) {
        buttonText.textContent = 'Add to cart';
      }

      return;
    }

    button.classList.remove('loading');

    if (buttonText) {

      buttonText.textContent = 'ADDED TO CART';

      setTimeout(function() {
        buttonText.textContent = 'Add to cart';
      }, 800);

    }

  };

}